<template>
  <ProgressRing :value="progressPercent(timeleft, time)" :size="120" :thickness="28">
    <p class="text-[44px] font-bold">
      {{ timeleft / 1000 }}
    </p>
  </ProgressRing>
</template>

<script lang="ts" setup>
const props = defineProps({
  time: { type: Number, required: false, default: () => 10 },
  timeleft: { type: Number, required: false, default: () => 10 },
});

const time = computed(() => props.time);
const timeleft = computed(() => props.timeleft);
</script>
